import React, { useState } from 'react';
import { QuizQuestion } from './QuizQuestion';
import type { QuizQuestion as QuizQuestionType } from '../../types/course';

interface Props {
  questions: QuizQuestionType[];
  onComplete: (score: number, total: number) => void;
}

export const QuizView: React.FC<Props> = ({ questions, onComplete }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);

  const handleAnswered = (isCorrect: boolean) => {
    const newScore = isCorrect ? score + 1 : score;
    setScore(newScore);

    // Small delay then advance
    setTimeout(() => {
      if (currentIndex < questions.length - 1) {
        setCurrentIndex((prev) => prev + 1);
      } else {
        onComplete(newScore, questions.length);
      }
    }, 400);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs font-medium text-[var(--clue-text-tertiary)] uppercase tracking-wide">
          Quiz
        </span>
        <span className="text-xs font-mono text-[var(--clue-text-secondary)]">
          {currentIndex + 1} / {questions.length}
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-1 rounded-full bg-[var(--clue-border-mid)] mb-6">
        <div
          className="h-full rounded-full bg-[var(--clue-green-accent)] transition-all duration-300"
          style={{ width: `${((currentIndex + 1) / questions.length) * 100}%` }}
        />
      </div>

      {/* Question - key forces remount on index change to reset state */}
      <div className="flex-1 overflow-y-auto">
        <QuizQuestion
          key={questions[currentIndex].id}
          question={questions[currentIndex]}
          onAnswered={handleAnswered}
        />
      </div>
    </div>
  );
};
